/**
 * @flow
 * @format
 */

import React from 'react';
import { connect, type Connector } from 'react-redux';
import { Card, Row, Col, Table, Button } from 'reactstrap';
import cc from 'classcat';
import _ from 'lodash';
import FaShoppingCart from 'react-icons/lib/fa/shopping-cart';
import FaDownload from 'react-icons/lib/fa/download';

import { actions as designActions } from '~/actions/design';
import { HashId } from '~/utils';

import classes from './BomWrapper.scss';

type OwnPropsType = {
  onExportBOM: Function,
  parts: {},
};

type EnhancedProps = {
  data: Array<*>,
  dispatch: Dispatch,
};

type PropsType = OwnPropsType & EnhancedProps;

const hashId = new HashId();

function replaceText(text: string): string {
  if (!text) return text;
  return text.replace(/>=/g, '≥').replace(/<=/g, '≤');
}

function generateLink(data: any[], part: string) {
  if (['ON Semiconductor', 'Fairchild'].includes(data[3])) {
    return (
      <a
        href={`/PowerSolutions/product.do?id=${part}`}
        rel="noopener noreferrer"
        target="_blank"
      >
        {part}
      </a>
    );
  }

  return part;
}

export class BomWrapper extends React.PureComponent<PropsType> {
  static defaultProps = {
    data: [],
    parts: {},
    onExportBOM: _.noop,
  };
  props: PropsType;

  render() {
    const { parts, data } = this.props;

    if (data.length === 0) {
      return null;
    }

    const head: string[] = _.first(data);
    const pkgIndex = head.indexOf('Part Number');
    const qtyIndex = head.indexOf('Qty');
    const manIndex = head.indexOf('Manufacturer');
    const desIndex = head.indexOf('Description');
    const headers = head.map((s: string) => <th key={s}>{s}</th>);
    const rows = _.tail(this.props.data).map(
      (r: Array<*>): ReactElementType => {
        if (_.every(r, _.isEmpty)) return null;
        return (
          <tr key={hashId.nextId()}>
            {r.map((s: string, j: number, arr): ReactElementType => {
              if (j === pkgIndex) {
                const partData = _.get(parts, s);
                if (!partData) return <td key={s}>{generateLink(arr, s)}</td>;

                return (
                  <td key={s}>
                    <a
                      href={partData.productPageUrl}
                      rel="noopener noreferrer"
                      target="_blank"
                    >
                      {s}
                    </a>
                    <span className="pull-xs-right">
                      {partData.sampleUrl ? (
                        <a
                          href={partData.sampleUrl}
                          rel="noopener noreferrer"
                          target="_blank"
                          className="btn btn-primary btn-sm"
                        >
                          <FaShoppingCart /> Sample
                        </a>
                      ) : null}{' '}
                      {partData.buyUrl ? (
                        <a
                          href={partData.buyUrl}
                          rel="noopener noreferrer"
                          target="_blank"
                          className="btn btn-primary btn-sm"
                        >
                          <FaShoppingCart /> Buy
                        </a>
                      ) : null}
                    </span>
                  </td>
                );
              } else if (j === qtyIndex) {
                return <td key={hashId.nextId()}>{parseInt(s, 10)}</td>;
              } else if (j === manIndex) {
                switch (s) {
                  case 'Fairchild':
                    return (
                      <td key={hashId.nextId()}>
                        <a
                          href="https://fairchildsemi.com"
                          rel="noopener noreferrer"
                          target="_blank"
                        >
                          {s}
                        </a>
                      </td>
                    );
                  case 'ON Semiconductor':
                    return (
                      <td key={hashId.nextId()}>
                        <a
                          href="https://onsemi.com"
                          rel="noopener noreferrer"
                          target="_blank"
                        >
                          {s}
                        </a>
                      </td>
                    );
                  default:
                    return <td key={hashId.nextId()}>{s}</td>;
                }
              } else if (j === desIndex) {
                return <td key={hashId.nextId()}>{replaceText(s)}</td>;
              }
              return <td key={hashId.nextId()}>{s}</td>;
            })}
          </tr>
        );
      },
    );

    return (
      <Row>
        <h4 className={cc(['col col-sm-12', classes.cardHeader])}>
          Powertrain Bill of Materials
          <Button className="ml-3" size="sm" onClick={this.props.onExportBOM}>
            <FaDownload /> Export BOM
          </Button>
        </h4>
        <Col>
          <Card body style={{ border: 0 }}>
            <Row>
              <Col>
                <Table
                  size="sm"
                  hover
                  striped
                  className={cc([classes.tableHeader])}
                >
                  <thead className={cc(['thead-inverse'])}>
                    <tr>{headers}</tr>
                  </thead>
                  <tbody>{rows}</tbody>
                </Table>
              </Col>
            </Row>
          </Card>
        </Col>
      </Row>
    );
  }
}

function mapStateToProps(state: AppStateType) {
  return {
    data: state.global.BOMTable,
  };
}

function mapDispatchToProps(dispatch: AppDispatch): {} {
  return {
    onExportBOM: () => dispatch(designActions.exportBOMToExcel()),
  };
}

const connector: Connector<OwnPropsType, PropsType> = connect(
  mapStateToProps,
  mapDispatchToProps,
);

export default connector(BomWrapper);



// WEBPACK FOOTER //
// ./src/components/BomWrapper/BomWrapper.js